import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { ChatButtonOpenComponent } from './components/chat-button-open/chat-button-open.component';
import { ChatWidgetComponent } from './components/chat-widget/chat-widget.component';
import { ChatWindowComponent } from './components/chat-window/chat-window.component';
import { FaqMenuLinkComponent } from './components/faq-menu-link/faq-menu-link.component';
import { FaqWidgetHostComponent } from './components/faq-widget-host/faq-widget-host.component';
import { FaqWindowComponent } from './components/faq-window/faq-window.component';
import { FaqService } from './services/faq.service';
import { HelpFaqEffects, HelpFaqReducers } from './store';

@NgModule({
  declarations: [
    FaqWindowComponent,
    FaqWidgetHostComponent,
    FaqMenuLinkComponent,
    ChatButtonOpenComponent,
    ChatWindowComponent,
    ChatWidgetComponent,
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    StoreModule.forFeature('helpFaq', HelpFaqReducers.Reducers.helpFaqReducer),
    EffectsModule.forFeature([HelpFaqEffects]),
  ],
  providers: [FaqService],
  exports: [
    FaqWindowComponent,
    FaqWidgetHostComponent,
    FaqMenuLinkComponent,
    ChatWidgetComponent,
  ],
})
export class HelpFaqModule {}
